
<button class="ui button checked" v-if="checked" @click.prevent="toggle"><i class="heart icon"></i>問い合わせリストに追加済</button>
<button class="ui button" v-else  @click.prevent="toggle"><i class="heart outline icon"></i>問い合わせリストに追加</button>
